import { defaultCtx } from "~/lib/AjaxCtx"

export default class ConnectorService {
    constructor(ctx) {
        this.$http = ctx || defaultCtx
    }

    async start(userActivityId) {
        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/start`
        )
    }

    async end({ userActivityId, sessionId, isClosing }) {
        if (isClosing) {
            return this.$http.sendBeacon(
                `/participant-activity/${userActivityId}/end`,
                { sessionId }
            )
        }

        return await this.$http.fetchData(
            `/participant-activity/${userActivityId}/end`,
            {
                method: "POST",
                body: JSON.stringify({ sessionId }),
            }
        )
    }
}
